import request from '@/utils/request'
import { ResponseData } from './modular'
/**
 * @description: 获取游戏分类列表
 * @param {*}
 * @return {*}
 */
export const getGameCategoryList = (data?: any) => {
  return request<ResponseData<any>>('/web/getGamesByCategory', {
    method: 'GET',
    showLoading: false,
    data,
  })
}

/**
 * @description: 游戏登录
 * @param {*}
 * @return {*}
 */
export const gameLogin = (data?: any) => {
  return request<ResponseData<any>>('/web/gameLogin', {
    method: 'POST',
    data,
  })
}

/**
 * @description: 获取游戏记录
 * @param {*}
 * @return {*}
 */
export const getGameRecord = (data?: any) => {
  return request<ResponseData<any>>('/web/getPlayersBetsList', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 获取游戏平台列表
 * @param {*}
 * @return {*}
 */
export const getGamePlatformList = (data?: any) => {
  return request<ResponseData<any>>('/web/getGamePlatforms', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 获取热门游戏
 * @param {*}
 * @return {*}
 */
export const getHotGameList = (data?: any) => {
  return request<ResponseData<any>>('/web/getHotGameList', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 获取赢钱列表
 * @param {*}
 * @return {*}
 */
export const getWinMoneyList = (data?: any) => {
  return request<ResponseData<any>>('/web/getBetWins', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 获取玩家游戏历史
 * @param {*}
 * @return {*}
 */
export const getPlayerGameHistory = (data?: any) => {
  return request<ResponseData<any>>('/web/getPlayersBetsList', {
    method: 'GET',
    data,
  })
}

/**
 * @description: 获取一级游戏厂商
 * @param {*}
 * @return {*}
 */
export const getGameProviderList = () => {
  return request<ResponseData<any>>('/web/getGamesByPlatform', {
    method: 'GET',
    data: {
      siteId: Number(import.meta.env.VITE_APP_SITE_ID),
    },
  })
}

/**
 * @description: 获取所有游戏
 * @param {*}
 * @return {*}
 */
export const getAllGameList = (data?: any) => {
  return request<ResponseData<any>>('/web/games', {
    method: 'GET',
    data,
  })
}
